// 省份或州级行政区划数据
export const provinceOrStateData = {
  Malaysia: [
    {
      value: "JOHOR",
      zh: "JOHOR 柔佛",
      en: "JOHOR",
    },
    {
      value: "KEDAH",
      zh: "KEDAH 吉打",
      en: "KEDAH",
    },
    {
      value: "KELANTAN",
      zh: "KELANTAN 吉兰丹",
      en: "KELANTAN",
    },
    {
      value: "MELAKA",
      zh: "MELAKA 马六甲",
      en: "MELAKA",
    },
    {
      value: "NEGERI SEMBILAN",
      zh: "NEGERI SEMBILAN 森美兰",
      en: "NEGERI SEMBILAN",
    },
    {
      value: "PAHANG",
      zh: "PAHANG 彭亨",
      en: "PAHANG",
    },
    {
      value: "PERAK",
      zh: "PERAK 霹雳",
      en: "PERAK",
    },
    {
      value: "PERLIS",
      zh: "PERLIS 玻璃市",
      en: "PERLIS",
    },
    {
      value: "PULAU PINANG",
      zh: "PULAU PINANG 槟城",
      en: "PULAU PINANG",
    },
    {
      value: "SABAH",
      zh: "SABAH 沙巴",
      en: "SABAH",
    },
    {
      value: "SARAWAK",
      zh: "SARAWAK 砂拉越",
      en: "SARAWAK",
    },
    {
      value: "SELANGOR",
      zh: "SELANGOR 雪兰莪",
      en: "SELANGOR",
    },
    {
      value: "TERENGGANU",
      zh: "TERENGGANU 登嘉楼",
      en: "TERENGGANU",
    },
    {
      value: "W.P. KUALA LUMPUR",
      zh: "W.P. KUALA LUMPUR 吉隆坡联邦直辖区",
      en: "W.P. KUALA LUMPUR",
    },
    {
      value: "W.P. LABUAN",
      zh: "W.P. LABUAN 纳闽联邦直辖区",
      en: "W.P. LABUAN",
    },
    {
      value: "W.P. PUTRAJAYA",
      zh: "W.P. PUTRAJAYA 布城联邦直辖区",
      en: "W.P. PUTRAJAYA",
    },
  ],
};
